import React, { Component } from 'react';
import { Grid, Typography, Paper, InputLabel } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import _sortBy from 'lodash/sortBy';
import TextField from '../../../common/TextField';
import _get from 'lodash/get';
import MomentUtils from '@date-io/moment';
import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider
} from 'material-ui-pickers';
import moment from 'moment';

const styles = {
  root: {
    padding: '2px 8px 2px 4px !important',
    display: 'flex',
    alignItems: 'center',
    minWidth: 100,
    background: '#fff',
    marginTop: '4px !important',
    borderRadius: 4,
    fontWeight: 300
  },
  input: {
    marginLeft: 8,
    width: '100%',
    '&:before': {
      display: 'none'
    },
    '&:after': {
      display: 'none'
    }
  },
  label: {
    fontSize: 14,
    fontWeight: 300,
    color: '#000'
  }
};

const DiscountAvailableUntil = ({
  classes,
  discount,
  discountId,
  updateDiscount
}) => {
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Grid container>
        <Typography variant="subtitle1">Discount available until:</Typography>
        <Grid
          container
          key={'style-titleText-'}
          direction="row"
          alignItems="flex-end"
          spacing={1}
          className={classes.container}
        >
          <Grid item xs={4}>
            <InputLabel className={classes.label}>Date</InputLabel>
            <DatePicker
              value={discount.availableUntil}
              onChange={e => {
                console.log(JSON.stringify(e));
                console.log(moment(e).valueOf());
                updateDiscount({
                  optimisticResponse: {
                    __typename: 'Mutation',
                    updateDiscount: {
                      ...discount,
                      availableUntil: moment(e).valueOf()
                    }
                  },
                  variables: {
                    id: discountId,
                    input: {
                      availableUntil: moment(e).valueOf()
                    }
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <InputLabel className={classes.label}>Time</InputLabel>
            <TimePicker
              value={discount.availableUntil}
              onChange={e => {
                // console.log(JSON.stringify(e));
                updateDiscount({
                  optimisticResponse: {
                    __typename: 'Mutation',
                    updateDiscount: {
                      ...discount,
                      availableUntil: moment(e).valueOf()
                    }
                  },
                  variables: {
                    id: discountId,
                    input: {
                      availableUntil: moment(e).valueOf()
                    }
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body1">
              GMT {moment().format('Z')} (your timezone)
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item>
            <Typography variant="body1">
              {new Date(discount.availableUntil).toGMTString()}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
};

DiscountAvailableUntil.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DiscountAvailableUntil);
